<div class="modal-header">
  <div class="d-flex align-items-center">
    <h4 class="modal-title" id="modal-basic-title">Cambia password</h4>
  </div>
  <ideapa-icon-button
    icon="close"
    cssClasses="text-primary hover-bg-primary"
    (clicked)="cancel()"
    >
  </ideapa-icon-button>
</div>
@if (form$ | async; as form) {
  <form
    [ngrxFormState]="form"
    (submit)="onSubmit(form)"
    >
    <div class="modal-body">
      <div class="col">
        <ideapa-text-field
          [label]="'Vecchia Password'"
          [controlType]="'password'"
          [ngrxFormControlState]="form.controls.password"
          [errors]="form.controls.password.errors | ngrxFormsErr"
          [shouldShowError]="form.controls.password.isSubmitted  && form.controls.password.isInvalid"
          >
        </ideapa-text-field>
      </div>
      <div class="col mt-4">
        <ideapa-text-field
          [label]="'Nuova Password'"
          [controlType]="'password'"
          [ngrxFormControlState]="form.controls.newPassword"
          [errors]="form.controls.newPassword.errors | ngrxFormsErr"
          [shouldShowError]="form.controls.newPassword.isSubmitted && form.controls.newPassword.isInvalid"
          >
        </ideapa-text-field>
      </div>
      <div class="mt-4 col">
        <ideapa-text-field
          [label]="'Conferma Password'"
          [controlType]="'password'"
          [ngrxFormControlState]="form.controls.confirmPassword"
          [errors]="form.controls.confirmPassword.errors | ngrxFormsErr"
          [shouldShowError]="form.controls.confirmPassword.isSubmitted  && form.controls.confirmPassword.isInvalid"
          >
        </ideapa-text-field>
      </div>
      <div class="mt-4">
        <div translate class="password-hint">
          La password deve essere lunga almeno 8 caratteri.<br />
          Deve contenere maiuscole e minuscole.<br />
          Deve contenere almeno un numero.<br />
          Deve contenere almeno un carattere speciale (!&#64;#$%^&*_-).
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <ideapa-button
        class="me-2"
        [cssClasses]="'btn-outline-primary'"
        [text]="'Annulla'"
        (clicked)="cancel()"
      ></ideapa-button>
      <ideapa-button
        type="submit"
        [cssClasses]="'btn-primary'"
        [text]="'Conferma'"
      ></ideapa-button>
    </div>
  </form>
}
